import React from 'react';
import { Button, Header, Icon, Modal, SemanticICONS } from 'semantic-ui-react';

interface Props {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    messageToDisplay: string;
    loading?: boolean;
    /** Customize for non-deletion confirmations (e.g. "Confirm Cancellation"). Defaults preserve the original delete-confirmation copy. */
    headerText?: string;
    headerIcon?: SemanticICONS;
    confirmText?: string;
    confirmColor?: 'red' | 'blue' | 'green' | 'orange' | 'grey';
    confirmIcon?: SemanticICONS;
    dismissText?: string;
}

const DeleteConfirmationModal = ({
    open,
    onClose,
    onConfirm,
    messageToDisplay,
    loading = false,
    headerText = 'Confirm Deletion',
    headerIcon = 'archive',
    confirmText = 'Delete',
    confirmColor = 'red',
    confirmIcon = 'checkmark',
    dismissText = 'Cancel',
}: Props) => (
    <Modal
        open={open}
        onClose={onClose}
        size="small"
        closeOnDimmerClick={!loading}
        centered
        className="delete-confirmation-modal"
    >
        <Header icon={headerIcon} content={headerText} />
        <Modal.Content>
            <p>{messageToDisplay}</p>
        </Modal.Content>
        <Modal.Actions>
            <Button onClick={onClose} disabled={loading}>
                <Icon name="remove" /> {dismissText}
            </Button>
            <Button color={confirmColor} onClick={onConfirm} loading={loading} disabled={loading}>
                <Icon name={confirmIcon} /> {confirmText}
            </Button>
        </Modal.Actions>
    </Modal>
);

export default DeleteConfirmationModal;
